import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpUtilService {

  constructor(private http: HttpClient) { }

  private token = 'token';
  headers() {
    let httpHeaders: HttpHeaders = new HttpHeaders();

    if (sessionStorage[this.token]) {
      httpHeaders = httpHeaders.set(
        'Content-Type',
        'application/json');

      httpHeaders = httpHeaders.set(
        'Authorization',
        'Bearer ' + sessionStorage[this.token]
      );
    }

    return { headers: httpHeaders };
  }

  headersWithParams(params2: URLSearchParams, parameterName: string) {
    let httpHeaders: HttpHeaders = new HttpHeaders();

    if (sessionStorage[this.token]) {
      httpHeaders = httpHeaders.set(
        'Content-Type',
        'application/json');

      httpHeaders = httpHeaders.set(
        'Authorization',
        'Bearer ' + sessionStorage[this.token]
      );
    }
    const params = new URLSearchParams();
    params.append('codigoSerial', '0000000000000000000000004799F650ACDD3C87');
    return params === undefined ? { headers: httpHeaders } : { headers: httpHeaders, search: params };
  }

  headersWithTokenMaquina(nomeToken, tokenConteudo) {
    let httpHeaders: HttpHeaders = new HttpHeaders();
    if (sessionStorage['token']) {
      httpHeaders = httpHeaders.set(
        'Content-Type',
        'application/json');
      httpHeaders = httpHeaders.set(
        'Authorization',
        'Bearer ' + sessionStorage['token']
      ); 
      if (localStorage[nomeToken]) {
        httpHeaders = httpHeaders.set(
          'tokenMaquina', JSON.stringify(tokenConteudo)
        );
      }

    }
    return { headers: httpHeaders };
  }


  obterDadosCertificado() {
    if (!sessionStorage[this.token]) {
      return '';
    }
    const certificateData = JSON.parse(atob(sessionStorage[this.token].split('.')[1]));
    return certificateData.sub;
  }

  obterInscricao() {
    if (!sessionStorage[this.token]) {
      return '';
    }
    const certificateData = JSON.parse(atob(sessionStorage[this.token].split('.')[1]));
    return certificateData.sub.inscricao;
  }

  obterTipoInscricao() {
    if (!sessionStorage[this.token]) {
      return '';
    }
    const certificateData = JSON.parse(atob(sessionStorage[this.token].split('.')[1]));
    return certificateData.sub.tpInscricao;
  }
  get(url: string): Observable<any> {
    return this.http.get(url,  this.headers());
  }

  post(url: string, parameters: any): Observable<any> {
    return this.http.post(url, parameters, this.headers());
  }

  put(url: string, parameters: any): Observable<any> {
    return this.http.put(url, parameters, this.headers());
  }

  async postWithHeader(url: string, parameters: any, nomeToken, tokenConteudo): Promise<Observable<any>> {
    return this.http.post(url, parameters, this.headersWithTokenMaquina(nomeToken, tokenConteudo));
  }

}
